import { styled } from "@mui/system";
import Box from "@mui/material/Box";

export const StyledFormBody = styled(Box)(() => ({
  border: "0",
  boxShadow: "none",
}));
